import { trimSpaces } from '../../../utils/utils';

export default {
    createDueRequest(formData) {
        let request =  {
            companyName: formData.companyName
        };

        if (false === formData.isSiren) {
            request.siret = formData.siret;
        }

        if (true === formData.isSiren) {
            request.siren = formData.siren;
        }

        if (formData.codeNaf) {
            request.codeNaf = formData.codeNaf;
        }

        if (false !== formData.collectiveAgreementId) {
            request.collectiveAgreementId = formData.collectiveAgreementId;
        }

        return request;
    },
    createFormDataForFirstStepFromResponse(response) {
        let formData = {
            isSiren: null
        };

        if (response.companyName) {
            formData.companyName = response.companyName;
        }

        if (response.siret) {
            formData.isSiren = false;
            formData.siret = response.siret;
        }

        if (response.siren) {
            formData.isSiren = true;
            formData.siren = response.siren;
        }

        if (response.codeNaf) {
            formData.codeNaf = response.codeNaf;
        }

        if (response.collectiveAgreement) {
            formData.collectiveAgreementId = response.collectiveAgreement.id;
        }

        return formData;
    },
    createContactLawyersRequest(formData) {
        let request =  {
            email: formData.email,
            message: formData.message,
            collectiveAgreement: formData.collectiveAgreement
        }

        if (formData.codeNaf) {
            request.codeNaf = formData.codeNaf;
        }

        if (formData.phoneNumber) {
            request.phoneNumber = trimSpaces(formData.phoneNumber);
        }

        return request;
    }
};
